import BaseModel from './BaseModel'
import {action, autorun, computed, makeObservable, observable, reaction} from 'mobx'
import Person from './Person'
import {isValidPhoneNumber} from 'libphonenumber-js'

export default class Member extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      id: observable,
      title: observable,
      phone_number: observable,
      user: observable,
      company: observable,
      company_id: observable,
      role_id: observable,
      role: observable,
      date_from: observable,
      date_to: observable,
      mother_id: observable,
      mother: observable,
      father_id: observable,
      father: observable,
      children: observable,
      forma_number: observable,
      year_born: observable,
      was_validated: observable,
      is_father: observable,
      is_mother: observable,
      add_child: action,
      remove_children: action,
      remove_child: action,
      validate: action,
      is_valid_phone_number: computed,
      is_role_valid: computed,
    })
    reaction(
      () => this.role_id,
      (newRole, previousRole) => {
        if (newRole === 'PRNT') {
          if (this.children.length === 0) {
            this.add_child()
          }
          if (!this.is_father && !this.is_mother) {
            this.setProperty('is_mother', true)
          }
        } else {
          this.remove_children()
          this.setProperty('is_mother', false)
          this.setProperty('is_father', false)
        }
      }
    );
  }
  
  id = 0;
  title = '';
  phone_number = '';
  user = null;
  company_id = 0;
  company = {};
  role_id = '';
  role = null;
  date_from = null;
  date_to = null;
  mother_id = 0;
  mother = new Person('mother');
  father_id = 0;
  father = new Person('father');
  children = [];
  forma_number = null;
  year_born = null;
  was_validated = false;
  is_father = false;
  is_mother = false;
  
  
  add_child = () => {
    this.children.push(new Person('child'));
  }
  remove_children = () => {
    this.children = [];
  }
  remove_child = (c) => {
    const index = this.children.indexOf(c);
    if (index > -1) {
      this.children.splice(index, 1);
    }
  }
  validate = () => {
    this.was_validated = true;
    if (this.role_id === 'MMBR') {
      this.mother.validate()
      this.father.validate()
    }
    if (this.role_id === 'PRNT') {
      this.children.forEach(child => {
        child.validate()
      })
    }
  
    return this.title && this.is_valid_phone_number && this.company_id && this.is_role_valid
  }
  
  get is_valid_phone_number() {
    let pn = this.phone_number;
    if (pn.startsWith('+')) {
      pn = pn.slice(1);
    }
    return isValidPhoneNumber('+' + pn)
  }
  
  get is_role_valid() {
    if (!this.role_id) {
      return false
    }
    if (this.role_id === 'PRNT') {
      if (this.children.length === 0) {
        return false
      }
      this.children.forEach(child => {
        if (!child.is_valid) {
          return false
        }
      })
    }
    
    if (this.role_id === 'MMBR') {
      if (!this.mother.is_valid || !this.father.is_valid) {
        return false
      }
    }
    
    return true
  }
}